/* eslint-disable react/prop-types */

/* eslint-disable @typescript-eslint/no-unused-vars */
import get from 'lodash/get';

import { bem } from '../../core/design/bem';
import useTranslations from '../../hooks/useTranslations';
import { replaceValues } from '../../utils/stringUtils';
import BlockContainer from '../BlockContainer';
import CTATilesBlock from './CTATilesBlock';

const pageBlock = bem('cta');
const translationPrefix = 'blocks.ctaTiles';

const ItemCTATilesBlock = ({ container, item, field, ...props }) => {
  const { t } = useTranslations(translationPrefix);
  const blocks = get(item, field);
  if (!blocks || blocks.length === 0) return null;

  return (
    <BlockContainer
      {...container}
      className={pageBlock({ variant: props?.variant }).toString()}
      header={replaceValues(container?.header || t('cta'), { ...item })}
    >
      <CTATilesBlock blocks={get(item, field)} {...props} />
    </BlockContainer>
  );
};

ItemCTATilesBlock.propTypes = {};

export default ItemCTATilesBlock;
